import { register } from "swiper/element/bundle";

const swiper = () => {
  const init = () => {
    execute();
  };

  const execute = () => {
    register();
  };
  init();
};

try {
  swiper();
} catch (error) {
  console.error("swiper", error);
}
